"use client";

import { DEFAULT_CURRENCY } from "@configs/currencies";
import { useClientValue } from "src/components/cashback/use-client-value";
import { getCurrencyBasedOnDomain, getMarketDomain } from "src/utils/domain.util";

/**
 * The shop's currency (host, or the `?currency=` QA override), safe to render.
 *
 * `getCurrencyBasedOnDomain()` reads `window`: on the server it is always
 * eur, in the browser it is the market's. Called during render, a pln, czk,
 * ron or eur-at page therefore hydrated server text against different client
 * text, which is React error #418 (final walk NEW-4, the /en RON checkout).
 * This renders the server's eur while hydrating and the real currency on the
 * very next render.
 */
export function useShopCurrencyValue(): string {
  return useClientValue(getCurrencyBasedOnDomain, DEFAULT_CURRENCY);
}

/** `getMarketDomain()` with the same hydration guarantee ("" on the server). */
export function useMarketDomain(): string {
  return useClientValue(getMarketDomain, "");
}
